import React from "react";
import "../Footer/footer.css";
import { FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaYoutube } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { FaPinterest } from "react-icons/fa";
import { IoCarSport } from "react-icons/io5";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="footer-main">
        <div className="footer-container">
          <div className="column-footer-1">
            <img src="/logo.webp" className="logo-f" alt="logo" />
            <p className="column-footer-1-text">
              At CA & Associates, we provide expert financial and legal
              assistance to help you achieve your business and personal
              financial goals with confidence.
            </p>

            <div className="social-icons-f">
              {/* Place your social media icons here */}
              <FaFacebook className="social-icon-footer" />

              <IoLogoWhatsapp className="social-icon-footer" />

              <FaSquareInstagram className="social-icon-footer" />
              <FaLinkedin className="social-icon-footer" />
            </div>
          </div>
          <div className="ll-f">
            <div className="column-footer">
              <h3 className="footer-heading">Our Pages</h3>
              <ul className="list-ul-footer">
                <li>
                  <Link to="/" className="footer-link-n">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/aboutus" className="footer-link-n">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/results" className="footer-link-n">
                    Case Results
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="footer-link-n">
                    Blogs
                  </Link>
                </li>
                <li>
                  <Link to="/contactus" className="footer-link-n">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
            <div className="column-footer">
              <h3 className="footer-heading">Services</h3>
              <ul className="list-ul-footer">
                <li>
                  <a href="#" className="footer-link-n">
                    Service 1
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link-n">
                    Service 2
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link-n">
                    Service 3
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link-n">
                    Service 4
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link-n">
                    Service 5
                  </a>
                </li>
              </ul>
            </div>
            <div className="column-footer">
              <h3 className="footer-heading">Locations</h3>
              <ul className="list-ul-footer">
                <li>
                  <a href="#" className="footer-link-n">
                    Location 1
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link-n">
                    Location 2
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link-n">
                    Location 3
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link-n">
                    Location 4
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link-n">
                    Location 5
                  </a>
                </li>
              </ul>
            </div>
            <div className="column-footer">
              <h3 className="footer-heading">Important Links</h3>
              <ul className="list-ul-footer">
                <li>
                  <a href="#" className="footer-link-n">
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link-n">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link-n">
                    Sitemap
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link-n">
                    Privacy Choices
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link-n">
                    Privacy Choices
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="footer-divider" />
      </footer>
    </>
  );
};

export default Footer;
